import type { WorkflowCapabilityReference } from './platform-workflow-definition-lifecycle.models';
import type { StepCommand } from './workflow-step-authoring.models';

const commandKeys = new Set(['capability', 'requirements', 'outcomes', 'captureForm', 'formConfiguration', 'inputBindings', 'outputBindings']);

/** Generic Add never silently selects the separately versioned Preparation handoff. */
export function isPreparationLookupCommand(reference: WorkflowCapabilityReference | null | undefined): boolean {
  const key = reference?.key;
  return key?.provider === 'workflow' && key.kind === 'command' && key.code === 'workflow.preparation.submit' && key.version === 2;
}

export function preparationLookupAuthoringReason(reference: WorkflowCapabilityReference | null | undefined): string {
  return isPreparationLookupCommand(reference)
    ? 'Choose Preparation v2 through its versioned setup. Existing forms and settings are preserved.' : '';
}

/** Closed saved content is checked without importing any form/editor value dependency. */
export function preparationLookupCommandShapeReason(command: StepCommand): string {
  return isPreparationLookupCommand(command.capability) && (Object.keys(command).some(key => !commandKeys.has(key)) || command.captureForm != null
    || command.inputBindings != null && (!Array.isArray(command.inputBindings) || command.inputBindings.length > 0)
    || command.outputBindings != null && (!Array.isArray(command.outputBindings) || command.outputBindings.length > 0)
    || !Array.isArray(command.requirements) || command.requirements.length > 0
    || !Array.isArray(command.outcomes) || command.outcomes.length > 0)
    ? 'This saved Preparation action contains unavailable bindings or dependencies. Its original content is preserved.' : '';
}
